export default "__VITE_ASSET__156237a8__"